import { Lugar } from 'src/app/servicios/lugares.service';
import { map } from 'rxjs/operators';
import { ResultadoServicio, LugaresUnidad } from './lugares.service';
import { Observable } from 'rxjs';
import { AutenticacionService } from 'src/app/servicios/autenticacion.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AreasService {

  constructor(
    private _http: HttpClient,
    private autenticacionService: AutenticacionService
  ) { }

  public areas: Map<number, Area> = new Map<number, Area>();

  traerAreasUnidad() {
    const dataLogin = this.autenticacionService.dataLogin;
    const requestUrl = `https://as-ws-smarthome.azurewebsites.net/api/unidades/unidad/${dataLogin.company_id}`;
  
    let headers = new HttpHeaders({
      dataAreas: 'true'
    });

    if(this.areas.size > 0) {
      return new Observable<Area[]>(subscriber => {
        subscriber.next([...this.areas.values()]);
        subscriber.complete();
      });
    } else {
      return <Observable<Area[]>>this._http.get(requestUrl, { headers })
            .pipe(
              map((res: ResultadoServicio<ListaAreas>) => {
                res.data.areas.forEach(area => {
                  this.areas.set(area.id, area);
                });
                return [...this.areas.values()];
              })
            );
    }
  }

  traerApartamentosArea(idArea: number) {
    const requestUrl = `https://as-ws-smarthome.azurewebsites.net/api/lugares/${idArea}/areas`;

    if(this.areas.get(idArea).apartamentos) {
      return new Observable<Lugar[]>(subscriber => {
        subscriber.next([...this.areas.get(idArea).apartamentos.values()]);
        subscriber.complete();
      });
    } else {
      return <Observable<Lugar[]>>this._http.get(requestUrl)
            .pipe(
              map((res: ResultadoServicio<LugaresUnidad>) => {
                const apartamentos = new Map<number, Lugar>();
                res.data.lugares.forEach(apartamento => {
                  apartamentos.set(apartamento.id, apartamento);
                })

                const areaActual = {...this.areas.get(idArea), apartamentos};
                this.areas.set(idArea, areaActual);
                
                return res.data.lugares;
              })
            );
    }
  }

  traerPersonasAutorizanVisitasPorApartamento(idArea: number, idApartamento: number) {
    const dataLogin = this.autenticacionService.dataLogin;

    const requestUrl = `https://as-ws-smarthome.azurewebsites.net/api/unidades/unidad/${dataLogin.company_id}`;

    let headers = new HttpHeaders({
      idLugar: String(idApartamento)
    });

    
    if(this.areas.get(idArea).apartamentos.get(idApartamento).miembros) {
      return new Observable<PersonaAutoriza[]>(subscriber => {
        subscriber.next([...this.areas.get(idArea).apartamentos.get(idApartamento).miembros]);
        subscriber.complete();
      });
    } else {
      return <Observable<PersonaAutoriza[]>>this._http.get(requestUrl, { headers })
      .pipe(
        map((res: ResultadoServicio<AutorizanVisitas>) => {
          const areaActual = this.areas.get(idArea);
          const apartamentoActual = {...areaActual.apartamentos.get(idApartamento), miembros: res.data.autorizan}
          areaActual.apartamentos.set(apartamentoActual.id, apartamentoActual);
          
          this.areas.set(idArea, areaActual);
          
          return res.data.autorizan;
        })
      );
    }

  }
}

export interface PersonaAutoriza {
  id: number,
  name: string,
  guest_allowed: number
}

export interface AutorizanVisitas {
  autorizan: PersonaAutoriza[]
}

export interface ListaAreas {
  areas: Area[]
}

export interface Area {
  id: number,
  descripcion: string,
  apartamentos: Map<number, Lugar>
}

